<template>
    <b-modal
        :id="modalId"
        class="modal-demo"
        title-class="text-light"
        header-bg-variant="dark"
        header-text-variant="light"
        title-tag="h4"
        size="lg"
        title="Manage stars"
        centered
        @hide="hideModal"
    >
        <div class="row">
            <div class="col-12 form-group">
                <label for="stars">Stars</label>
                <input
                    id="stars"
                    v-model="formData.stars"
                    class="form-control"
                    :class="{ 'is-invalid': hasError('stars') }"
                    type="number"
                    dir="auto"
                />
                <div class="invalid-feedback">
                    {{ getError('stars') }}
                </div>
                <small>
                    If you want to reduce value then insert negative number
                </small>
            </div>
            <div class="col-12 form-group">
                <label for="description">Description</label>
                <textarea
                    id="description"
                    v-model="formData.description"
                    class="form-control rtl"
                    :class="{ 'is-invalid': hasError('description') }"
                    rows="5"
                    dir="auto"
                />
                <div class="invalid-feedback">
                    {{ getError('description') }}
                </div>
            </div>
        </div>
        <template #modal-footer>
            <div class="col-12 d-flex justify-content-between">
                <button
                    type="submit"
                    class="btn btn-danger waves-effect waves-light"
                    @click="hideModal"
                >
                    Close
                </button>
                <button
                    type="submit"
                    class="btn btn-success waves-effect waves-light"
                    @click="save"
                >
                    Save
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { StatusCodes as HTTP } from 'http-status-codes';

export default {
    validations: {
        formData: {
            stars: {
                required,
                hasToBeDifferentThanZero: v => {
                    v = parseInt(v);

                    if (isNaN(v)) {
                        return false;
                    }

                    return v !== 0;
                }
            },
            description: {
                required
            }
        }
    },

    props: {
        modalId: {
            type: String,
            required: false,
            default: 'manage-stars-modal'
        },
        userId: {
            type: String,
            required: true
        },
        successMessage: {
            type: String,
            required: false,
            default: 'Stars stock changed!'
        }
    },

    data() {
        const defaultForm = {
            stars: 0,
            description: ''
        };

        return {
            defaultForm,
            formData: { ...defaultForm },
            serverErrors: []
        };
    },

    methods: {
        ...mapActions({
            manageStars: 'users/manageStars'
        }),

        hideModal() {
            this.$bvModal.hide(this.modalId);

            this.$v.$reset();
        },

        async save() {
            this.serverErrors = [];

            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            try {
                const item = await this.manageStars({
                    ...this.formData,
                    userId: this.userId
                });

                this.$emit('changed', item);
                this.hideModal();
                this.formData = { ...this.defaultForm };

                this.$toaster(this.successMessage);
            } catch (error) {
                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (status === HTTP.BAD_REQUEST && data.errors) {
                        this.serverErrors = data.errors;

                        this.$toasterError('Recheck your form.');

                        return;
                    }
                }

                console.error(error);

                this.$toasterError();
            }
        },

        hasError(key) {
            return (
                this.$v.formData[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.$v.formData,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
